module.exports = __webpack_public_path__ + "static/media/microscope3.a10211c7.jpg";